<template>
    <div class="mobile-form-container">
        <branding-header />

        <div class="completion-content">
            <div class="completion-header">
                <v-icon
                    :size="36"
                    color="primary"
                    class="completion-icon"
                >mdi-check-circle</v-icon>
                <h3 class="completion-title">{{ header_text }}</h3>
            </div>

            <p class="completion-description">
                {{ description_text }}
            </p>
        </div>

        <div
            v-if="is_change_request"
            class="info-section"
        >
            <h4 class="section-title">
                What Happens Next?
            </h4>

            <div class="mobile-info-grid">
                <div class="mobile-info-item">
                    <div class="info-row">
                        <v-icon
                            color="primary"
                            size="16"
                            class="info-icon"
                        >mdi-clock-outline</v-icon>
                        <div class="info-content">
                            <div class="info-label">Response Time</div>
                            <div class="info-text">We'll get back to you within 2 business days</div>
                        </div>
                    </div>
                </div>

                <div class="mobile-info-item">
                    <div class="info-row">
                        <v-icon
                            color="primary"
                            size="16"
                            class="info-icon"
                        >mdi-help-circle-outline</v-icon>
                        <div class="info-content">
                            <div class="info-label">Questions?</div>
                            <div class="info-text">Contact us at 555-123-4567</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BrandingHeader from '@/components/demos/shared/branding-header.vue';

export default {
    name: 'CompletionDemo',

    components: {
        BrandingHeader
    },

    props: {
        is_change_request: {
            type: Boolean,
            default: false
        },

        submission_data: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            messageIndex: 1,
            conversationKey: 0,
            showTyping: false
        }
    },

    computed: {
        has_text_consent() {
            return this.submission_data?.has_text_consent || false;
        },

        header_class() {
            return this.is_change_request ? 'primary--text' : 'success--text';
        },

        header_text() {
            return this.is_change_request ? 'Change Request Received' : 'Thank You!';
        },

        description_text() {
            if (this.is_change_request) {
                return `We'll review your request and get back to you soon`;
            }

            return 'Your order confirmation has been received';
        },
    },
}
</script>

<style lang="scss" scoped>
.completion-content {
    margin-bottom: 1rem;
}

.completion-header {
    text-align: center;
    margin-bottom: 0.5rem;

    .completion-icon {
        display: block;
        margin: 0 auto 0.5rem;
    }

    .completion-title {
        font-size: 1.1rem;
        font-weight: 600;
        margin: 0;
        color: var(--v-primary-base);
    }
}

.completion-description {
    color: var(--color-text, #666);
    font-size: 0.85rem;
    text-align: center;
    margin: 0 0 1rem 0;
    line-height: 1.3;
    text-wrap: balance;
}

.info-section {
    background: #f5f5f5;
    border-radius: 0.5rem;
    padding: 0.75rem;
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;

    .section-title {
        display: flex;
        align-items: center;
        font-size: 0.9rem;
        font-weight: 600;
        margin-bottom: 0.75rem;
        color: var(--v-primary-base);
        gap: 0.25rem;
    }
}

.mobile-info-grid {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.mobile-info-item {
    background: white;
    border-radius: 0.375rem;
    padding: 0.75rem;

    .info-row {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;

        .info-icon {
            margin-top: 0.125rem;
            flex-shrink: 0;
        }

        .info-content {
            flex: 1;
            min-width: 0;
            text-align: left;

            .info-label {
                font-weight: 600;
                color: var(--v-primary-base);
                font-size: 0.8rem;
                margin-bottom: 0.25rem;
            }

            .info-text {
                color: #555;
                font-size: 0.75rem;
                line-height: 1.3;
            }
        }
    }
}

:deep(.v-btn) {
    text-transform: none;
    letter-spacing: normal;

    &.v-btn--outlined {
        border-width: 1.5px;
    }
}

:deep(.v-icon) {
    &.v-icon--left {
        margin-right: 0.375rem;
    }
}
</style>
